export default __webpack_public_path__ + "static/media/icon.45bedfdf.png";